export const messages = {
    internetStore: 'فروشگاه اینترنتی',
    justByNow: 'همین الان خرید کن!',
    allKindsDetergentProducts: 'انواع محصولات خوراکی و شوینده',
    lowerPrice: 'با بهای کمتر، مستقیم و بدون واسطه از کارخانه',
    famusBrand: 'برندهای نام آشنا',
    likeOnline: 'بصورت آنلاین',
    instagram: 'اینستاگرام',
    instagramLink: 'https://www.instagram.com/SarfeMarket/',
    googlePlayLink: "https://play.google.com/store/apps/details?id=com.apptech.topchino_customer",
    cafeBazaarLink: 'https://cafebazaar.ir/app/com.apptech.topchino_customer',
    ok: 'باشه',
    error: 'خطا',
    successPayment_1: 'پرداخت موفق',
    errorPayment: 'پرداخت ناموفق',
    warning: 'هشدار',
    success: 'موفق',
    farvardin: 'فروردین',
    forExample: 'برای مثال 09123456789',
    ordibehesht: 'اردیبهشت',
    khordad: 'خرداد',
    tir: 'تیر',
    mordad: 'مرداد',
    shahrivar: 'شهریور',
    mehr: 'مهر',
    aban: 'آبان',
    azar: 'آذر',
    dey: 'دی',
    bahman: 'بهمن',
    esfand: 'اسفند',
    user: 'کاربر',
    successAddOrder: "سفارش شما با موفقیت در سیستم ثبت گردید",
    orderId: " کد پیگیری ",
    basketChangeMessage: "سبد خرید شما تغییر یافته است لطفا مجددا به سبد خود برگردید و پس از مشاهده تغییرات اقدام به ثبت سفارش نمایید",
    basketChange: "تغییر در سبد خرید",
    basketChangeTitle: "سبد خرید شما تغییر یافته است",
    userInviteYou: 'شما را به جمع ما دعوت کرده است، برای پیوستن به خانواده بزرگ صرفه مارکت لطفا شماره تماس خود را وارد کنید',
    userAccount: 'حساب کاربری',
    editTelephone: 'اصلاح شماره',
    myOrders: 'سفارشات من',
    aboutUs: 'درباره ما',
    myRewards: 'جایزه های من',
    basket: 'سبد خرید',
    return: 'بازگشت',
    search: 'جستجو',
    searchBrand: 'جستجو برند',
    yourLocation: 'موقعیت شما',
    driverLocation: 'موقعیت پیک شما',
    searchPlace: 'نام منطقه، محله، خیابان و ...',
    inCategory: " در دسته ",
    showAllSearchFor: "نمایش همه نتایج برای ",
    telephone: 'شماره موبایل',
    phone: 'تلفن',
    attention: 'توجه',
    messageTitle: 'عنوان پیام',
    relatedProducts: 'محصولات مشابه',
    otherBuy: 'دیگران این کالاها را نیز خرید کرده اند',
    messageDescription: 'متن پیام',
    yourInviteCode: 'کد معرفی شما',
    verifyCode: 'کد فعالسازی',
    fullName: 'نام و نام خانوادگی',
    email: 'پست الکترونیک',
    nationalId: 'کد ملی',
    birthDate: 'تاریخ تولد',
    male: 'مهربان ( مرد )',
    female: 'مهربانو ( زن )',
    verifyCodeSendedTo: " کد فعالسازی پیامک شده به شماره ",
    entedIt: " را وارد کنید ",
    inviteCode: 'کد معرف (اختیاری)',
    home: 'خانه',
    sarfeMarketEn: 'SarfeMarket',
    count: 'تعداد',
    resend: 'ارسال مجدد',
    category: 'دسته بندی کالاها',
    connectWithUsAddress: 'آدرس ما',
    connectWithUs: 'ارتباط با ما',
    applicationDownload: 'دانلود اپلیکیشن',
    forApplicationDownload: 'برای دانلود اپلیکیشن صرفه مارکت لطفا بر روی مارکت دلخواه خود کلیک کنید',
    connectWithUsPhone: 'تلفن تماس با ما',
    connectWithUsEmail: 'ارتباط از طریق پست الکترونیک',
    seggestionDescription: 'لطفا انتقادات و پیشنهادات خود را جهت بهتر شدن صرفه مارکت با ما درمیان بگذارید',
    orders: 'سفارشات',
    orderNumber: 'شماره سفارش',
    ticketNumber:"کد پیگیری",
    customerClub: 'باشگاه مشتریان',
    download: 'دانلود',
    seeAll: 'مشاهده همه',
    returnToMainPage: 'بازگشت به صفحه اصلی',
    enter: 'ورود',
    city: 'شهر',
    editAddress: 'ویرایش آدرس',
    submitFilterPrice: 'اعمال محدوده قیمت',
    use: 'اعمال',
    deleteFromCart: 'حذف کالا',
    deleteAddress: 'حذف آدرس',
    deleteNotification: 'حذف اعلان',
    sureCancelOrder: 'آیا اطمینان دارید می خواهید سفارش خود را ابطال کنید؟',
    sureEditOrder: 'آیا اطمینان دارید می خواهید سفارش خود را ویرایش کنید؟',
    sureCompleteOrder: 'آیا اطمینان دارید می خواهید سفارش خود را تکمیل کنید؟',
    expireDate: 'تاریخ انقضا',
    edit: 'ویرایش',
    subject: 'موضوع',
    peykLocation: 'مشاهده موقعیت موزع',
    completeOrder: 'تکمیل سفارش',
    editOrder: 'ویرایش سفارش',
    addToBasket: 'افزودن به سبد خرید',
    selectAddress: 'انتخاب آدرس',
    selectTimeAddress: 'انتخاب آدرس و زمان',
    selectDefaultPaymentTypePlease: "لطفا شیوه پرداخت را انتخاب کنید",
    selectDefaultAddressPlease: "لطفا آدرس پیش فرض را انتخاب کنید",
    selectDeliverDatePlease: "لطفا روز و ساعت ارسال سفارش را انتخاب نمایید",
    selectDeliverAddress: 'انتخاب آدرس تحویل',
    addressNotFound: 'آدرسی برای شما یافت نشد، لطفا آدرس تحویل خود را ثبت نمایید',
    selectDeliverType: 'انتخاب زمان ارسال',
    selectPaymentType: 'انتخاب روش پرداخت',
    finalRegister: 'نهایی سازی',
    orderRegister: 'ثبت سفارش',
    showOrder: 'مشاهده سفارش',
    pay: 'پرداخت',
    backToSelectDateTime: 'بازگشت به صفحه انتخاب تاریخ و ساعت',
    changeAddress: 'تغییر آدرس',
    editReward: 'ویرایش جایزه',
    clearBasket: 'خالی کردن سبد',
    notifyMe: 'موجود شد خبرم کن',
    dontNotifyMe: 'دیگ لازم نیست خبرم کنی',
    sendMessage: 'ثبت پاسخ جدید',
    copy: 'کپی لینک',
    activate: 'فعالسازی',
    inviteFriends: "دعوت از دوستان",
    notifications: "اعلانات",
    invited: "دعوت شده ها",
    inviteDescription: "کاربر گرامی جهت معرفی صرفه مارکت به دوستانتان لطفا لینک زیر رو براشون ارسال کنید",
    trackingCodeCopied: "کد پیگیری کپی شد",
    inviteLinkCopied: "لینک معرفی به دوستان کپی شد",
    discountCodeCopied: "کد تخفیف کپی شد",
    sarfeBonCopied: "صرفه بن کپی شد",
    registered: "ثبت نام شده ها",
    logout: "خروج از حساب کاربری",
    login: "ورود به حساب کاربری",
    sureLogin: "فرآیند ورود شما تکمیل نشده است، به منظور ادامه فرآیند ابتدا باید وارد شوید، آیا مایل هستید؟",
    sureLogout: "آیا می خواهید از حساب کاربری خود خارج شوید؟",
    sureDeleteAddress: "آیا از حذف آدرس اطمینان دارید؟",
    sureDeleteFromCart: "آیا از حذف کالا از سبد خرید اطمینان دارید؟",
    sureDeleteNotification: "آیا از حذف اعلان اطمینان دارید؟",
    sureClearBasket: "آیا از خالی کردن سبد خرید اطمینان دارید؟",
    myAddress: "آدرس های من",
    addAddress: "افزودن آدرس",
    addIamge: "افزودن تصویر",
    addVoice: "ضبط پیام صوتی",
    addRate: "ثبت نظر",
    isEmpty: " خالی می باشد ",
    list: " لیست ",
    addressesListEmpty: "لیست آدرس های شما خالی می باشد",
    rewardListEmpty: "لیست جایزه های شما خالی می باشد",
    productListEmpty: "لیست کالاها خالی می باشد",
    productList: "لیست محصولات",
    orderListEmpty: "لیست سفارشات شما خالی می باشد",
    ticketListEmpty: "لیست تیکت های شما خالی می باشد",
    notificationListEmpty: "لیست اعلانات شما خالی می باشد",
    basketIsEmpty: "سبد خرید شما خالی می باشد",
    pleaseSelectLocation: "لطفا موقعیت مکانی خود را بر روی نقشه تعیین کنید",
    addAddressError: "در فرآیند ثبت آدرس خطایی رخ داده است",
    rateOrderError: "در فرآیند ثبت امتیاز برای سفارش خطایی رخ داده است",
    pleaseFillAllInfo: "پر کردن همه ی گزینه ها الزامی است",
    cannotDeleteAddress: "به دلیل داشتن سفارش فعال با این آدرس، امکان ویرایش و یا حذف آن تا نهایی شدن سفارش امکان پذیر نمی باشد",
    toAddNewAddress: " جهت افزودن آدرس جدید بر روی دکمه ",
    pleaseSelectRate: "لطفا امتیاز سفارش را انتخاب کنید",
    clicked: " کلیک کنید ",
    account: "حساب کاربری",
    dearUser: " کاربر گرامی ",
    welcome: " خوش آمدید ",
    priceUnit: " تومان ",
    percentUnit: " درصد ",
    more: "بیشتر",
    seeMore: "مشاهده بیشتر",
    less: "کمتر",
    seeLess: "مشاهده کمتر",
    validityTo: " اعتبار تا ",
    free: "رایگان",
    productNotExist: "متاسفانه این کالا در انبار صرفه مارکت موجود نمی باشد",
    ipgResultError: "کاربر گرامی، اطلاعات پرداخت معتبر نمی باشد، لطفا به صفحه انتخاب تاریخ و ساعت بازگردید و مجددا مراحل ثبت سفارش را انجام دهید",
    ipgWalletResultError: "کاربر گرامی، اطلاعات پرداخت معتبر نمی باشد، لطفا به صفحه کیف پول بازگردید و مجددا مراحل را انجام دهید",
    price: "قیمت",
    priceRange: "محدوده قیمت",
    fee: "مبلغ",
    value: "مقدار",
    minValue: "حداقل مبلغ سفارش",
    maxValue: "حداکثر مبلغ سفارش",
    totalPrice: "مبلغ کل",
    totalOrderPrice: "مبلغ سفارش",
    totalFactorOrderPrice: "قیمت فاکتور",
    totalOrderPriceNew: "قیمت نهایی",
    products_discount: "قیمت فاکتور",
    paymentPrice: "مبلغ",
    submit: "تایید",
    cancel: "انصراف",
    cancelOrder: "لغو سفارش",
    detailOrder: "جزئیات سفارش",
    is: "هست",
    isNot: "نیست",
    oldPrice: "قیمت قدیم",
    allCategory: " همه دسته‌بندی‌های ",
    support: "پشتیبانی",
    onlinePayment: "اینترنتی",
    cashPayment: "نقدی",
    posPayment: "کارت خوان",
    roleAndCondition: "قوانین و شرایط ",
    sarfeMarket: " صرفه مارکت ",
    sarfeMarketEmail: "info@sarfemarket.ir",
    sarfeMarketInstagram: "Sarfemarket@",
    sarfeMarketAddress: "تهران، خیابان آزادی، بلوار استاد معین، پلاک 172",
    criticsAndSuggestion: "درخواست پشتیبانی ",
    readAndAccept: " را خوانده ام و قبول دارم.",
    remainingTime: "فرصت دارید",
    productRemovedFromBasket: "کالا به دلیل عدم موجودی از سبد خرید حذف گردید",
    productCountChangeFrom: " تعداد انتخابی این کالا از ",
    productPriceChangeFrom: " قیمت این کالا از ",
    changed: " تغییر یافت ",
    fromTime: "از ساعت",
    initPrice: "اعتبار اولیه",
    remainingPrice: "باقیمانده اعتبار",
    to: "تا",
    number: "قلم",
    toBe: " به ",
    day: "روز",
    month: "ماه",
    year: "سال",
    time: "ساعت",
    yes: "بله",
    no: "خیر",
    downloadApp: "دریافت اپلیکیشن",
    usefullInApp: "کارایی بهتر در اپلیکیشن",
    allOrder: "همه سفارشات",
    confirmWaitingOrder: "سفارشات در انتظار تایید",
    confirmOrder: "سفارشات تایید شده",
    sendingOrder: "سفارشات در حال ارسال",
    watingForPaymentInfo: "درحال دریافت اطلاعات پرداخت، لطفا منتظر بمانید...",
    watingForRegisterPaymentInfo: "درحال نهایی سازی سفارش، لطفا منتظر بمانید...",
    deliveredOrder: "سفارشات تکمیل شده",
    canceledOrder: "سفارشات باطل شده",
    hour: "ساعت",
    minute: "دقیقه",
    gateway: "درگاه",
    secend: "ثانیه",
    guaranteeProduct: "ضمانت اصل بودن کالا",
    paymentType: "روش پرداخت",
    transactionHistory: "تاریخچه تراکنش ها",
    payInPlace: "پرداخت در محل",
    deliverInPlace: "ارسال به موقع",
    deliverTakeName: " نام تحویل گیرنده ",
    deliverDate: "تاریخ دریافت سفارش",
    deliverDate_1: "تاریخ دریافت",
    RegistrationDate: "تاریخ ثبت",
    paymentDate: "تاریخ و ساعت",
    paymentDeliverName: "نام پذیرنده",
    acceptorName: "نام پذیرنده",
    paymentCode: "کد پیگیری",
    successPayment: "پرداخت شما با موفقیت انجام شد",
    errorPayment_1: "پرداخت شما با موفقیت انجام نشد",
    successOrderRegister: "سفارش شما با موفقیت ثبت شد",
    orderSendAt: "سفارش شما در تاریخ و ساعت انتخاب شده به آدرس مشخص شده ارسال می گردد",
    deliverTakePhone: " تلفن تحویل گیرنده ",
    fullAddress: " آدرس دقیق ",
    enterFullAddress: " آدرس کامل خود را وارد نمایید ",
    titleAddress: "عنوان آدرس",
    finishOrder: "تکمیل سفارش",
    driverStatusChanged: "تغییر وضعیت راننده",
    driverStatusChangedMessage: "مشتری گرامی امکان مشاهده مسیر حرکت موزع لغو گردید",
    finishOrderMessage: "مشتری گرامی با تشکر از خرید شما",
    deliverAddress: "آدرس تحویل",
    deliverTakeAddress: "آدرس تحویل گیرنده",
    state: "استان",
    address: "آدرس",
    brand: "برند",
    sort: "مرتب سازی",
    filter: "فیلتر",
    deleteFilters: "حذف فیلتر ها",
    status: "وضعیت",
    paymentDetail: "جزئیات پرداخت",
    paymentDetailForFinalSubmit: "جزئیات پرداخت جهت تایید نهایی",
    orderStatus: "وضعیت سفارش",
    system: "(سیستمی)",
    productCount: "تعداد کالا",
    newest: "جدیدترین",
    lowCost: "ارزان ترین",
    highCost: "گران ترین",
    famous: "محبوب ترین",
    highDiscount: "بيشترين تخفيفات",
    from: "از",
    discount: "تخفيف",
    enterDiscountCode: "لطفا کد تخفیف را وارد کنید",
    discountCodeUsedBefore: "این کد قبلا در سبد شما اعمال گردیده است",
    discountCodeError: "در اعمال کد تخفیف خطایی رخ داده است",
    sendVerifyCodeError: 'خطا در ارسال کد فعالسازی',
    youreBeforeRegister: 'شما قبلا ثبت نام کرده اید',
    youreBeforeInvited: 'شما قبلا فرآیند ورود از طریق لینک دعوت از دوستان را انجام داده اید',
    wrongPhoneNumber: 'شماره موبایل ارسالی صحیح نمی باشد',
    orderNotFound: 'سفارش یافت نشد',
    orderCannotBeEdit: 'وضعیت سفارش در حال انتظار نمی باشد و امکان ويرايش وجود ندارد',
    orderCannotBeComplete: 'وضعیت سفارش در اننظار پرداخت اینترنتی نمی باشد و امکان تکمیل  وجود ندارد',
    timeVerifyCodeError: 'زمان ارسال کد فعالسازی زیر نود ثانیه است',
    productDiscount: "تخفيفات کالایی",
    specialDiscount: "تخفیفات ویژه",
    excessDiscount: "تخفیف مازاد",
    transportationCost: "هزینه حمل",
    netTotal: "قابل پرداخت",
    priceNetTotal: "مبلغ قابل پرداخت",
    onlyExistProduct: "فقط کالاهای موجود",
    onlyDiscountProduct: "محصولات تخفیف دار",
    exist: "موجود",
    notExist: "ناموجود",
    description: "توضیحات",
    specification: "مشخصات",
    productDescription: "توضیحات کالا",
    productDetail: "مشخصات کالا",
    detail: "جزئیات",
    neighbourhood: "محله",
    responseCodeIsNot200: "خطایی رخ داده است",
    articleNotFound: "مقاله مورد نظر یافت نشد",
    successCancelOrder: "سفارش شما با موفقیت باطل شد",
    sendMessageError: "در ارسال پیام خطایی رخ داده است",
    fillTitleOrDescription: "لطفا اطلاعات مورد نیاز را وارد کنید",
    verifyNotSuccess: "موبایل یا کد فعالسازی یا کد معرف ارسالی صحیح نمی باشد",
    resendError: 'متاسفانه در ارسال مجدد کد فعالسازی خطایی رخ داده است',
    deleteAddressError: 'متاسفانه در حذف آدرس خطایی رخ داده است',
    setDefaultAddressError: 'متاسفانه در تغییر آدرس پیش فرض خطایی رخ داده است',
    editProfileSuccess: "اطلاعات کاربری شما با موفقیت تغییر یافت",
    sendMessageSuccess: "پیام شما با موفقیت ارسال شد",
    deleteAddressSuccess: "حذف آدرس با موفقیت انجام شد",
    deleteNotificationSuccess: "حذف اعلان با موفقیت انجام شد",
    addAddressSuccess: "افزودن آدرس با موفقیت انجام شد",
    editAddressSuccess: "ویرایش آدرس با موفقیت انجام شد",
    rateOrderSuccess: "امتیازدهی به سفارش با موفقیت انجام شد",
    setDefaultAddressSuccess: "تغییر آدرس پیش فرض با موفقیت انجام شد",
    emailError: 'فرمت ایمیل ارسالی صحیح نمی باشد',
    emailDupliate: 'ایمیل تکراری است',
    nationalIdError: 'کد ملی ارسالی صحیح نمی باشد',
    birthdateError: 'تاریخ تولد اشتباه است',
    pleaseEnterVerifyCode: "لطفا کد فعالسازی را وارد کنید",
    pleaseWait: "لطفا منتظر بمانید",
    pleaseCheckAggrement: "لطفا قوانین و شرایط را مطالعه و تایید نمایید",
    productIsLimit: "محدودیت موجودی کالا در انبار",
    enterTelephone: "شماره موبایل خود را وارد کنید",
    suppurtNumber: "66055000 021",
    rateOrderText_2: ' شما، جهت بهبود کیفیت ارائه خدمات صرفه مارکت لطفا یکی از صورتک های زیر را انتخاب کنید و درصورت داشتن توضیحات اضافی، آن را در کادر مربوطه وارد کنید ',
    rateOrderText_1: ' کاربر گرامی با تشکر از سفارش ',
    you: '  ',
    environmentSupporter: 'حامی محیط زیست',
    iAmEnvironmentSupporter: 'نیاز به فاکتور ندارم',
    curentValueWallet: 'موجودی ',
    useWallet: 'پرداخت از طریق کیف پول',
    wallet: 'کیف پول',
    inventory:'موجودی',
    descriptionEnvironmentSupporter: 'مشتری گرامی، با علامت زدن این گزینه فاکتور چاپی برای شما صادر نمی شود و در مصرف کاغذ صرفه جویی خواهد شد',
    howToConnectWithUsMessage1: 'نظرات و پیشنهادات خود را از طریق شماره تلفن',
    howToConnectWithUsMessage2: 'و پست الکترونیک info@sarfemarket.ir با ما درمیان بگذارید',
    sarfeDescription: 'در فروشگاه اینترنتی صرفه مارکت تلاش داریم با شعار سریع، آسان، مطمئن با صرفه در کوتاه ترین زمان ممکن، با امکان انتخاب ساده و آسان محصولات در اپلیکیشن و یا وب سایت و با اطمینان از کیفیت مناسب کالا، خریدی با قیمت مناسب و با صرفه را برای شما خریدار محترم به ارمغان بیاوریم',
    sarfeCopyright: 'کلیه حقوق این وبسایت متعلق به شرکت به\u200cپخش می باشد',
    aggrementText: "کلیه اصول و رویه های صرفه مارکت منطبق با قوانین جمهوری اسلامی ایران، قانون تجارت الکترونیک و قانون حمایت از حقوق مصرف کننده است.\n" +
        "ورود کاربران به صرفه مارکت به معنای آگاه بودن و پذیرفتن شرایط و قوانین صرفه مارکت است. در صورتی که در قوانین مندرج و رویه ها تغییری ایجاد شود در همین صفحه منتشر و بروزرسانی می شود و شما توافق می کنید که استفاده مستمر شما از صرفه مارکت، به معنی پذیرش تغییرات می باشد.\n" +
        "برای استفاده از صرفه مارکت لازم است که هر کاربر یک حساب کاربری در صرفه مارکت بسازد، برای استفاده از صرفه مارکت کاربر باید نام و نام خانوادگی و شماره همراه خود را وارد کند، مسئولیت وارد کردن اطلاعات اشتباه و غیر واقعی از قبیل نام و نام خانوادگی، شماره تماس و آدرس (در هنگام ثبت سفارش) به عهده کاربر است.\n" +
        "هر فرد تنها می تواند یک حساب کاربری در صرفه مارکت داشته باشد و مسئولیت همه فعالیت هایی که از طریق حساب کاربری در صرفه مارکت انجام می شود به عهده کاربر است.\n" +
        "صرفه مارکت به حریم خصوصی کاربران خود احترام می گذارد و متعهد به حفاظت از اطلاعات شخصی است که شما در اختیار آن می گذارید.",



    tickets:"درخواست پشتیبانی",
    addTicket:"ثبت درخواست پشتیبانی",
    ticketDetail:"جزئیات درخواست پشتیبانی",
    ticketStatus:"وضعیت",
    maxCountSelectImage:"حداکثر تعداد عکس انتخابی بیشتر از حد مجاز است",
    maxSizeSelectImage:"حداکثر سایز عکس انتخابی بیشتر از حد مجاز است",
    maxFileSelectSize:"حجم فایل انتخابی صحیح نمی باشد",
    errorDescription:"متن پیام را وارد کنید",
    errorSubject:"موضوع را انتخاب نمایید",
    customersScore:"امتیاز و نظر مشتریان",
    score:"امتیاز",
    setScore:"امتیاز دهید",
    suggest:"پیشنهاد شده ",
    submitComment:"ثبت دیدگاه",
    LeaveACommentAboutThisProduct:"شما هم درباره این کالا دیدگاه ثبت کنید",
    customerComments:"نظر مشتریان",
    productComment:"دیدگاه",
    imageList:"لیست تصاویر",
    CommentsImageList:"لیست تصاویر ارسالی مشتری",
    CommentForProduct:"در مورد کالای ",
    textComment:"متن دیدگاه",
    errorScoreComment:"امتیاز نمی تواند صفر باشد",
    errorTextComment:"متن دیدگاه را وارد کنید",
    errorCountTextComment:"متن دیدگاه کوتاه می باشد",
    errorCharsetTextComment:"متن دیدگاه باید فارسی باشد",
    beforSetCommentPleaseLigin:'برای ثبت دیدگاه لطفا وارد حساب کاربری خود شوید',
    enterComment:"دیدگاه خود را شرح دهید",

};

export default messages